import { render } from "./ListNegocios.vue?vue&type=template&id=49e2c23b"
import script from "./ListNegocios.vue?vue&type=script&lang=js"
export * from "./ListNegocios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__